// extracted by mini-css-extract-plugin
module.exports = {"headerTitle":"BooksetListView__headerTitle","count":"BooksetListView__count"};